import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ResourceService } from '@direction/translate';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, of, Subject, tap } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { StudentService } from 'src/app/core/services/student.service';
import { TurnstileService } from 'src/app/core/services/turnstile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-biometry',
  templateUrl: './modal-biometry.component.html',
  styleUrls: ['./modal-biometry.component.scss']
})
export class ModalBiometryComponent implements OnInit {
  confirmResult!: Subject<boolean>;
  formBiometry!: FormGroup;
  messageStatus: string;
  imageFingerPrint: string;
  showRenewFingerprint = false;
  showSpinner: boolean = false;

  @Input() public title: string = '';
  @Input() public nationalId: string = '';

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private studentService: StudentService,
    private resourceService: ResourceService,
    private turnstileService: TurnstileService
  ) {}

  renewFingerprint(): void {
    this.imageFingerPrint = null;
    this.showSpinner = true;
    setTimeout(() => {
      if (this.nationalId) {
        this.messageStatus = this.resourceService.getResource('@direction.pages.student.modalBiometry.messageStatus');
        this.turnstileService.getUnitCode().subscribe((unitCode) => {
          if (!unitCode) return;
          this.turnstileService.getTurnstilesByUnitCode(unitCode).subscribe((turnstiles) => {
            if (turnstiles.value.length <= 0) return;
            let uriFingerReader = turnstiles.value[0].uriFingerReader;

            this.studentService
              .getFingerPrints(this.nationalId, environment.expireTimeFingerprint, uriFingerReader)
              .pipe(
                tap((response) => {
                  this.imageFingerPrint = this.helpersService.completedBase64(response.image);
                  this.messageStatus = this.resourceService.getResource(
                    '@direction.pages.student.modalBiometry.messageStatusConfirm'
                  );
                  this.formBiometry.patchValue({
                    fir: response.fir,
                    image: response.image
                  });
                  this.showRenewFingerprint = true;
                  this.showSpinner = false;
                }),
                catchError((err) => {
                  this.showRenewFingerprint = true;
                  this.showSpinner = false;
                  this.messageStatus = this.resourceService.getResource('@direction.pages.student.modalBiometry.messageTimeout');
                  return of[err];
                })
              )
              .subscribe();
          });
        });
      }
    }, 500);
  }

  ngOnInit(): void {
    this.formBiometry = this.fb.group({
      fir: this.fb.control(null),
      image: this.fb.control(null)
    });
    this.confirmResult = new Subject();
    this.renewFingerprint();
  }

  onConfirm() {
    this.confirmAndClose(this.formBiometry.value);
  }

  private confirmAndClose(value: any) {
    this.confirmResult.next(value);
    this.bsModalRef.hide();
  }
}
